/* eslint-disable react-hooks/exhaustive-deps */

import App from '../../layout/App';
import {
  FormContent, Container, Message,
  Box, Select as SelectComum, Option,
  TitleFieldForm, Box50, Madatory, TextLabel,
} from '../../styles/styles'
import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import api from '../../utils/api'
//usado para a validação dos forms
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import Loading from '../../Components/Loading';
import Checkbox from '../../Components/checkbox';
import { ClearMask } from '../../utils/mask';
import MessagePopUp from '../../Components/messagePopUp';
import InfoForm from '../../Components/infoForm'
import ButtonFormFooter from '../../Components/buttonFormFooter';
import { MessageContext } from '../../context/message';
import { desabilitaCampoRecebeEscolarização } from '../../utils/validationStudent';
import { validationForm3 } from '../../utils/validationStudent';
import { useIndexedLabels } from '../../utils/useIndexedLabels';


function TransporteAluno(props) {
  const {
    getTitleIndex,
    getIndexByLabel,
  } = useIndexedLabels();
  const [messageRequired, setMessageRequired] = useState([])
  const inep = sessionStorage.getItem('inep')
  const [removeLoad, setRemoveLoad] = useState(true)
  const [Organization, setOrganization] = useState()
  const { setErrorMessage } = useContext(MessageContext);
  const navigate = useNavigate()



  const { register, handleSubmit, setValue, formState: { errors } } = useForm({
    resolver: yupResolver(validationForm3)
  });

  const onSubmit = async (data) => {
    let dados = {
      ...Organization,
      cep : ClearMask(Organization?.cep),
      wasChanged : true,
      inepRelation : inep,
    }
    dados.cep = ClearMask(dados.cep)
    dados.wasChanged = true
    dados.inepRelation = inep
    sessionStorage.setItem('AlunoEditar', JSON.stringify(dados))
    api.put('/student/', dados).then((response) => {
      setErrorMessage([{ message: "Aluno atualizado com sucesso!", ok: true }])
      navigate('/aluno/pesquisar', { replace: true })
    }).catch(errors => {
      setRemoveLoad(true)
      setErrorMessage([{ message: "Erro ao atualizar aluno", ok: false }])
    })
  }
  useEffect(() => {
    if (errors) {
      const entries = Object.entries(errors).map(([key, error]) => ({
        id: key + '-' + error.message,
        fieldName: key,
        error,
      }));
      setMessageRequired(entries);
    }
  }, [errors]);

    useEffect(() => {
  
      let Aluno = JSON.parse(sessionStorage.getItem('AlunoEditar'))
      setOrganization(Aluno)
    }, [])

  return (
    <> {!removeLoad && <Loading />}
      <div className='span-message'>
        {messageRequired.map(({ id, fieldName, error }) => {
          const idx = getIndexByLabel(fieldName) || "";
          const text = error.message;

          return (
            <MessagePopUp
              key={id}
              title={`Campo ${idx} - obrigatório`}
              text={text}
              onClose={() =>
                setMessageRequired(prev => prev.filter(m => m.id !== id))
              }
            />
          );
        })}
      </div>
      <App>
        <Container>
          <InfoForm
            title="Aluno"
            wasChanged={Organization?.wasChanged}
            subtitle="Organização"
            positionPagination="3/3"
          />
          <form onSubmit={handleSubmit(onSubmit)} style={{ display: 'flex', gap: '10px', flexDirection: 'column' }}>
            <FormContent style={{ display: Organization?.aclass?.typeServices?.specializedEducationalService === 1 ? 'block' : 'none' }}>

              <Box >
                <TitleFieldForm>
                  {getTitleIndex('Tipo de atendimento educacional especializado', 'specializedEducationTypes', 
                    (Organization?.aclass?.typeServices?.specializedEducationalService !== null 
                    || Organization?.aclass?.typeServices?.specializedEducationalService !== undefined)? (Organization?.aclass?.typeServices?.specializedEducationalService === 1):false)}<Madatory>*</Madatory>
                </TitleFieldForm>
                <Message>{errors.specializedEducationTypes?.message}</Message>
                <Checkbox
                  name='specializedEducationTypes[0]'
                  setValue={setValue('specializedEducationTypes[0]', Organization?.specializedEducationTypes?.developmentCognitiveFunctions ?? 0)}
                  register={register('specializedEducationTypes[0]')}
                  checked={Organization?.specializedEducationTypes?.developmentCognitiveFunctions === 1 ? true : false}
                  onChange={(e) => setOrganization({
                    ...Organization, specializedEducationTypes: {
                      ...Organization?.specializedEducationTypes,
                      developmentCognitiveFunctions: e.target.checked ? 1 : 0
                    }
                  })}
                  title="Desenvolvimento de funções cognitivas" />
                <Checkbox
                  name='specializedEducationTypes[1]'
                  setValue={setValue('specializedEducationTypes[1]', Organization?.specializedEducationTypes?.autonomousLifeDevelopment ?? 0)}
                  register={register('specializedEducationTypes[1]')}
                  checked={Organization?.specializedEducationTypes?.autonomousLifeDevelopment === 1 ? true : false}
                  onChange={(e) => setOrganization({
                    ...Organization, specializedEducationTypes: {
                      ...Organization?.specializedEducationTypes,
                      autonomousLifeDevelopment: e.target.checked ? 1 : 0
                    }
                  })}
                  title="Desenvolvimento de vida autônoma" />
                <Checkbox
                  name='specializedEducationTypes[2]'
                  setValue={setValue('specializedEducationTypes[2]', Organization?.specializedEducationTypes?.curriculumEnrichment ?? 0)}
                  register={register('specializedEducationTypes[2]')}
                  checked={Organization?.specializedEducationTypes?.curriculumEnrichment === 1 ? true : false}
                  onChange={(e) => setOrganization({
                    ...Organization, specializedEducationTypes: {
                      ...Organization?.specializedEducationTypes,
                      curriculumEnrichment: e.target.checked ? 1 : 0
                    }
                  })}
                  title="Enriquecimento curricular" />
                <Checkbox
                  name='specializedEducationTypes[3]'
                  setValue={setValue('specializedEducationTypes[3]', Organization?.specializedEducationTypes?.affordableComputerEducation ?? 0)}
                  register={register('specializedEducationTypes[3]')}
                  checked={Organization?.specializedEducationTypes?.affordableComputerEducation === 1 ? true : false}
                  onChange={(e) => setOrganization({
                    ...Organization, specializedEducationTypes: {
                      ...Organization?.specializedEducationTypes,
                      affordableComputerEducation: e.target.checked ? 1 : 0
                    }
                  })}
                  title="Ensino da informática acessível" />
                <Checkbox
                  name='specializedEducationTypes[4]'
                  setValue={setValue('specializedEducationTypes[4]', Organization?.specializedEducationTypes?.teachingLibras ?? 0)}
                  register={register('specializedEducationTypes[4]')}
                  checked={Organization?.specializedEducationTypes?.teachingLibras === 1 ? true : false}
                  onChange={(e) => setOrganization({
                    ...Organization, specializedEducationTypes: {
                      ...Organization?.specializedEducationTypes,
                      teachingLibras: e.target.checked ? 1 : 0
                    }
                  })}
                  title="Ensino da Língua Brasileira de Sinais (Libras)" />
                <Checkbox
                  name='specializedEducationTypes[5]'
                  setValue={setValue('specializedEducationTypes[5]', Organization?.specializedEducationTypes?.teachingPortugueseSecondLanguage ?? 0)}
                  register={register('specializedEducationTypes[5]')}
                  checked={Organization?.specializedEducationTypes?.teachingPortugueseSecondLanguage === 1 ? true : false}
                  onChange={(e) => setOrganization({
                    ...Organization, specializedEducationTypes: {
                      ...Organization?.specializedEducationTypes,
                      teachingPortugueseSecondLanguage: e.target.checked ? 1 : 0
                    }
                  })}
                  title="Ensino da Língua Portuguesa como Segunda Língua" />
                <Checkbox
                  name='specializedEducationTypes[6]'
                  setValue={setValue('specializedEducationTypes[6]', Organization?.specializedEducationTypes?.teachingCalculusTechniquesSoroban ?? 0)}
                  register={register('specializedEducationTypes[6]')}
                  checked={Organization?.specializedEducationTypes?.teachingCalculusTechniquesSoroban === 1 ? true : false}
                  onChange={(e) => setOrganization({
                    ...Organization, specializedEducationTypes: {
                      ...Organization?.specializedEducationTypes,
                      teachingCalculusTechniquesSoroban: e.target.checked ? 1 : 0
                    }
                  })}
                  title="Ensino das técnicas do cálculo no Soroban" />
                <Checkbox
                  name='specializedEducationTypes[7]'
                  setValue={setValue('specializedEducationTypes[7]', Organization?.specializedEducationTypes?.teachingBrailleSystem ?? 0)}
                  register={register('specializedEducationTypes[7]')}
                  checked={Organization?.specializedEducationTypes?.teachingBrailleSystem === 1 ? true : false}
                  onChange={(e) => setOrganization({
                    ...Organization, specializedEducationTypes: {
                      ...Organization?.specializedEducationTypes,
                      teachingBrailleSystem: e.target.checked ? 1 : 0
                    }
                  })}
                  title="Ensino de Sistema Braille" />
                <Checkbox
                  name='specializedEducationTypes[8]'
                  setValue={setValue('specializedEducationTypes[8]', Organization?.specializedEducationTypes?.teachingTechniquesOrientationMobility ?? 0)}
                  register={register('specializedEducationTypes[8]')}
                  checked={Organization?.specializedEducationTypes?.teachingTechniquesOrientationMobility === 1 ? true : false}
                  onChange={(e) => setOrganization({
                    ...Organization, specializedEducationTypes: {
                      ...Organization?.specializedEducationTypes,
                      teachingTechniquesOrientationMobility: e.target.checked ? 1 : 0
                    }
                  })}
                  title="Ensino de técnicas para orientação e mobilidade" />
                <Checkbox
                  name='specializedEducationTypes[9]'
                  setValue={setValue('specializedEducationTypes[9]', Organization?.specializedEducationTypes?.teachingCAA ?? 0)}
                  register={register('specializedEducationTypes[9]')}
                  checked={Organization?.specializedEducationTypes?.teachingCAA === 1 ? true : false}
                  onChange={(e) => setOrganization({
                    ...Organization, specializedEducationTypes: {
                      ...Organization?.specializedEducationTypes,
                      teachingCAA: e.target.checked ? 1 : 0
                    }
                  })}
                  title="Ensino de uso da Comunicação Alternativa e Aumentativa (CAA)" />
                <Checkbox
                  name='specializedEducationTypes[10]'
                  setValue={setValue('specializedEducationTypes[10]', Organization?.specializedEducationTypes?.teachingUseOpticalNonOpticalResources ?? 0)}
                  register={register('specializedEducationTypes[10]')}
                  checked={Organization?.specializedEducationTypes?.teachingUseOpticalNonOpticalResources === 1 ? true : false}
                  onChange={(e) => setOrganization({
                    ...Organization, specializedEducationTypes: {
                      ...Organization?.specializedEducationTypes,
                      teachingUseOpticalNonOpticalResources: e.target.checked ? 1 : 0
                    }
                  })}
                  title="Ensino de uso de recursos ópticos e não ópticos" />
              </Box>
              <Box50 style={{ display: desabilitaCampoRecebeEscolarização(Organization?.aclass) ? 'flex' : 'none' }}>
                <TitleFieldForm>
                  {getTitleIndex('Recebe escolarização em outro espaço (diferente da escola)', 'receiveEducationElsewhere', !desabilitaCampoRecebeEscolarização(Organization?.aclass))} <Madatory>*</Madatory>
                </TitleFieldForm>
                <SelectComum
                  name='receiveEducationElsewhere'
                  {...register('receiveEducationElsewhere')}
                  {...setValue('receiveEducationElsewhere', Organization?.receiveEducationElsewhere ?? 0)}
                  value={Organization?.receiveEducationElsewhere}
                  onChange={e => setOrganization({
                    ...Organization, receiveEducationElsewhere: Number(e.target.value)
                  })}>
                  <Option value={0} disabled hidden>selecione</Option>
                  <Option value={1}>Não recebe escolarização fora da escola</Option>
                  <Option value={2}>Em hospital</Option>
                  <Option value={3}>Em domicílio</Option>
                </SelectComum>
                <Message>{errors.receiveEducationElsewhere?.message}</Message>
              </Box50>
            </FormContent>
            <FormContent>
              <Box50>
                <TitleFieldForm>
                  {getTitleIndex('Transporte público', 'usesTransportPublic')} <Madatory>*</Madatory>
                </TitleFieldForm>
                <SelectComum
                  name='usesTransportPublic'
                  {...register('usesTransportPublic')}
                  {...setValue('usesTransportPublic', Organization?.schoolTransports?.usesTransportPublic ?? -1)}
                  value={Organization?.schoolTransports?.usesTransportPublic ?? -1}
                  onChange={e => setOrganization({
                    ...Organization, schoolTransports: {
                      ...Organization?.schoolTransports,
                      usesTransportPublic: Number(e.target.value)
                    }
                  })}>
                  <Option value={-1} disabled hidden>selecione</Option>
                  <Option value={0} >Não utiliza</Option>
                  <Option value={1} >Utiliza</Option>
                </SelectComum>
                <Message>{errors.usesTransportPublic?.message}</Message>
              </Box50>
              <Box50 style={{ display: Organization?.schoolTransports?.usesTransportPublic === 1 ? 'block' : 'none' }} >
                <TitleFieldForm>
                  {getTitleIndex('Poder Público responsável pelo Organization escolar', 'responsiblePublicAuthority', Organization?.schoolTransports?.usesTransportPublic === 1)} <Madatory>*</Madatory>
                </TitleFieldForm>
                <SelectComum
                  name='responsiblePublicAuthority'
                  {...register('responsiblePublicAuthority')}
                  {...setValue('responsiblePublicAuthority', Organization?.schoolTransports?.responsiblePublicAuthority ?? 0)}
                  value={Organization?.schoolTransports?.responsiblePublicAuthority}
                  onChange={e => setOrganization({
                    ...Organization, schoolTransports: {
                      ...Organization?.schoolTransports,
                      responsiblePublicAuthority: Number(e.target.value)
                    }
                  })}>
                  <Option value={0} disabled hidden>selecione</Option>
                  <Option value={1} >Estadual</Option>
                  <Option value={2} >Municipal</Option>
                </SelectComum>
                <Message>{errors.responsiblePublicAuthority?.message}</Message>
              </Box50>

              <Box style={{ display: Organization?.schoolTransports?.usesTransportPublic === 1 ? 'block' : 'none' }} >
                <TitleFieldForm>
                  {getTitleIndex('Tipo de veículo utilizado no Organization escolar público', 'vehicleTypes', Organization?.schoolTransports?.usesTransportPublic === 1)}
                </TitleFieldForm>
                <Message>{errors.vehicleTypes?.message}</Message>
                <Checkbox
                  name='vehicleTypes[0]'
                  setValue={setValue('vehicleTypes[0]', Organization?.schoolTransports?.vehicleTypes?.roadBicycle ?? 0)}
                  register={register('vehicleTypes[0]')}
                  checked={Organization?.schoolTransports?.vehicleTypes?.roadBicycle === 1 ? true : false}
                  onChange={(e) => setOrganization({
                    ...Organization, schoolTransports: {
                      ...Organization?.schoolTransports, vehicleTypes: {
                        ...Organization?.schoolTransports?.vehicleTypes,
                        roadBicycle: e.target.checked ? 1 : 0
                      }
                    }
                  })}
                  title="Rodoviário - Bicicleta" />
                <Checkbox title="Rodoviário - Microônibus"
                  name='vehicleTypes[1]'
                  setValue={setValue('vehicleTypes[1]', Organization?.schoolTransports?.vehicleTypes?.roadMinibus)}
                  register={register('vehicleTypes[1]')}
                  checked={Organization?.schoolTransports?.vehicleTypes?.roadMinibus === 1 ? true : false}
                  onChange={(e) => setOrganization({
                    ...Organization, schoolTransports: {
                      ...Organization?.schoolTransports, vehicleTypes: {
                        ...Organization?.schoolTransports?.vehicleTypes,
                        roadMinibus: e.target.checked ? 1 : 0
                      }
                    }
                  })}
                />
                <Checkbox title="Rodoviário - Ônibus"
                  name='vehicleTypes[2]'
                  setValue={setValue('vehicleTypes[2]', Organization?.schoolTransports?.vehicleTypes?.roadBus)}
                  register={register('vehicleTypes[2]')}
                  checked={Organization?.schoolTransports?.vehicleTypes?.roadBus === 1 ? true : false}
                  onChange={(e) => setOrganization({
                    ...Organization, schoolTransports: {
                      ...Organization?.schoolTransports, vehicleTypes: {
                        ...Organization?.schoolTransports?.vehicleTypes,
                        roadBus: e.target.checked ? 1 : 0
                      }
                    }
                  })}
                />
                <Checkbox title="Rodoviário – Tração Animal"
                  name='vehicleTypes[3]'
                  setValue={setValue('vehicleTypes[3]', Organization?.schoolTransports?.vehicleTypes?.roadAnimalTraction)}
                  register={register('vehicleTypes[3]')}
                  checked={Organization?.schoolTransports?.vehicleTypes?.roadAnimalTraction === 1 ? true : false}
                  onChange={(e) => setOrganization({
                    ...Organization, schoolTransports: {
                      ...Organization?.schoolTransports, vehicleTypes: {
                        ...Organization?.schoolTransports?.vehicleTypes,
                        roadAnimalTraction: e.target.checked ? 1 : 0
                      }
                    }
                  })}
                />
                <Checkbox title="Rodoviário - Vans/Kombis"
                  name='vehicleTypes[4]'
                  setValue={setValue('vehicleTypes[4]', Organization?.schoolTransports?.vehicleTypes?.roadVanKombis)}
                  register={register('vehicleTypes[4]')}
                  checked={Organization?.schoolTransports?.vehicleTypes?.roadVanKombis === 1 ? true : false}
                  onChange={(e) => setOrganization({
                    ...Organization, schoolTransports: {
                      ...Organization?.schoolTransports, vehicleTypes: {
                        ...Organization?.schoolTransports?.vehicleTypes,
                        roadVanKombis: e.target.checked ? 1 : 0
                      }
                    }
                  })}
                />
                <Checkbox title="Rodoviário - Outro"
                  checked={Organization?.schoolTransports?.vehicleTypes?.roadOther === 1 ? true : false}
                  name='vehicleTypes[5]'
                  setValue={setValue('vehicleTypes[5]', Organization?.schoolTransports?.vehicleTypes?.roadOther)}
                  register={register('vehicleTypes[5]')}
                  onChange={(e) => setOrganization({
                    ...Organization, schoolTransports: {
                      ...Organization?.schoolTransports, vehicleTypes: {
                        ...Organization?.schoolTransports?.vehicleTypes,
                        roadOther: e.target.checked ? 1 : 0
                      }
                    }
                  })}
                />
                <Checkbox title="Aquaviário - Capacidade de até 5 aluno(a)s"
                  checked={Organization?.schoolTransports?.vehicleTypes?.waterways5 === 1 ? true : false}
                  name='vehicleTypes[6]'
                  setValue={setValue('vehicleTypes[6]', Organization?.schoolTransports?.vehicleTypes?.waterways5)}
                  register={register('vehicleTypes[6]')}
                  onChange={(e) => setOrganization({
                    ...Organization, schoolTransports: {
                      ...Organization?.schoolTransports, vehicleTypes: {
                        ...Organization?.schoolTransports?.vehicleTypes,
                        waterways5: e.target.checked ? 1 : 0
                      }
                    }
                  })}
                />
                <Checkbox title="Aquaviário - Capacidade entre 5 a 15 aluno(a)s"
                  checked={Organization?.schoolTransports?.vehicleTypes?.waterways15 === 1 ? true : false}
                  name='vehicleTypes[7]'
                  setValue={setValue('vehicleTypes[7]', Organization?.schoolTransports?.vehicleTypes?.waterways15)}
                  register={register('vehicleTypes[7]')}
                  onChange={(e) => setOrganization({
                    ...Organization, schoolTransports: {
                      ...Organization?.schoolTransports, vehicleTypes: {
                        ...Organization?.schoolTransports?.vehicleTypes,
                        waterways15: e.target.checked ? 1 : 0
                      }
                    }
                  })}
                />
                <Checkbox title="Aquaviário - Capacidade entre 15 a 35 aluno(a)s"
                  name='vehicleTypes[8]'
                  setValue={setValue('vehicleTypes[8]', Organization?.schoolTransports?.vehicleTypes?.waterways35)}
                  register={register('vehicleTypes[8]')}
                  checked={Organization?.schoolTransports?.vehicleTypes?.waterways35 === 1 ? true : false}
                  onChange={(e) => setOrganization({
                    ...Organization, schoolTransports: {
                      ...Organization?.schoolTransports, vehicleTypes: {
                        ...Organization?.schoolTransports?.vehicleTypes,
                        waterways35: e.target.checked ? 1 : 0
                      }
                    }
                  })}
                />
                <Checkbox title="Aquaviário - Capacidade acima de 35 aluno(a)s"
                  checked={Organization?.schoolTransports?.vehicleTypes?.waterwaysMore35 === 1 ? true : false}
                  name='vehicleTypes[9]'
                  setValue={setValue('vehicleTypes[9]', Organization?.schoolTransports?.vehicleTypes?.waterwaysMore35 ?? null)}
                  register={register('vehicleTypes[9]')}
                  onChange={(e) => setOrganization({
                    ...Organization, schoolTransports: {
                      ...Organization?.schoolTransports, vehicleTypes: {
                        ...Organization?.schoolTransports?.vehicleTypes,
                        waterwaysMore35: e.target.checked ? 1 : 0
                      }
                    }
                  })}
                />
              </Box>
            </FormContent>
            <TextLabel style={{ display: 'none' }}
              name='specializedEducationalService'
              setValue={setValue('specializedEducationalService', Organization?.aclass?.typeServices?.specializedEducationalService ?? 0)}
              register={register('specializedEducationalService')}
            />

            <TextLabel style={{ display: 'none' }}
              name=''
              setValue={setValue('isReceiveEducationElsewhere',
                desabilitaCampoRecebeEscolarização(Organization?.aclass) ?? false)}
              register={register('isReceiveEducationElsewhere')}
            />
            <ButtonFormFooter
              textNext="Salvar"
              linkBack={"/aluno/editar-dados-pessoais"}
            />
          </form>
        </Container>
      </App>
    </>
  )

}
export default TransporteAluno;